import { render, staticRenderFns } from "./TradeConfirmation.vue?vue&type=template&id=44f96c3a&scoped=true&"
import script from "./TradeConfirmation.vue?vue&type=script&lang=js&"
export * from "./TradeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./TradeConfirmation.vue?vue&type=style&index=0&id=44f96c3a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f96c3a",
  null
  
)

export default component.exports